export enum DialogsHubEventTypes {
    HANDLE_ROUTED_DIALOG = "HandleRoutedDialog",
    HANDLE_MESSAGE = "HandleMessage",
    DETACH_DIALOG = "DetachDialog",
    HOLD_DIALOG_UPDATED_MESSAGE = "HoldDialogUpdatedMessage",
    LINKED_CLIENT_ADDED = "LinkedClientAdded",
    LINKED_CLIENT_REMOVED = "LinkedClientRemoved",
    PINNED_MESSAGES = "PinnedMessages",
    START_AUTO_HOLDING_TIMER = "OnStartAutoHoldingTimer",
    STOP_AUTO_HOLDING_TIMER = "OnStopAutoHoldingTimer"
}
export type DialogsHubEventCallback = (data: unknown) => Promise<void>
export type DialogsHubEvents = Record<DialogsHubEventTypes, DialogsHubEventCallback>
